import { render, staticRenderFns } from "./Jobs.yaml?vue&type=template&id=24c2ebae&component"
import script from "./Jobs.yaml?vue&type=script&lang=ts&component"
export * from "./Jobs.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports